<mat-tab-group>
  <mat-tab label="Add-Ons"><app-wcl-addons></app-wcl-addons> </mat-tab>
  <mat-tab label="Location settings"
    ><app-wcl-locations></app-wcl-locations>
  </mat-tab>
</mat-tab-group>
